// 금천아 빌려줘 — 수령·반납 방법 수동 변경 (상세 화면)
//
// 옵션 추가 전에 들어온 주문, 주문 후 고객이 방법을 바꾼 경우에 담당자가 고친다.
// 저장은 PATCH rental/orders/{id}/ { fulfillment_override } 하나뿐이다.
//   "delivery" | "direct" → 수동 지정(옵션 판정보다 우선)
//   ""                    → 수동 지정 해제(옵션 판정으로 되돌림)
// 카드 표기·캘린더 제목·환불 기준액은 서버가 같은 값(resolve_fulfillment)으로 맞춘다.
// ⚠️ 회수완료 주문은 환불액이 이미 확정돼 서버가 거부한다 — 화면도 버튼을 막는다.
import React, { useState } from "react";

import api from "../../api";
import { formatDateTime } from "./format";

const OPTIONS = [
  { value: "delivery", label: "배송·회수" },
  { value: "direct", label: "직접 수령·반납" },
];
const PICKED_UP = "PICKED_UP";

export default function FulfillmentEditor({ order, onSaved }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const locked = order.status === PICKED_UP;

  const save = async (value) => {
    setSaving(true);
    setError("");
    try {
      const res = await api.patch(`rental/orders/${order.id}/`, { fulfillment_override: value });
      if (onSaved) onSaved(res.data);
    } catch (e) {
      setError(e?.response?.data?.detail || "수령·반납 방법을 바꾸지 못했습니다.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rental-fulfillment-editor">
      <div className="rental-fulfillment-editor-buttons">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`rental-fulfillment-btn${
              order.fulfillment === option.value ? " rental-fulfillment-btn--active" : ""
            }`}
            onClick={() => save(option.value)}
            disabled={locked || saving || order.fulfillment === option.value}
          >
            {option.label}
          </button>
        ))}
        {order.fulfillment_manual && (
          <button
            type="button"
            className="rental-fulfillment-btn rental-fulfillment-btn--reset"
            onClick={() => save("")}
            disabled={locked || saving}
            title="수동 지정을 지우고 카페24 옵션 값으로 판정합니다"
          >
            옵션 기준으로
          </button>
        )}
      </div>
      <div className="rental-fulfillment-editor-meta">
        {saving
          ? "저장 중…"
          : order.fulfillment_manual
          ? `수동 변경 · ${order.fulfillment_override_by_name || "-"} · ${formatDateTime(
              order.fulfillment_override_at
            )}`
          : "카페24 옵션 기준"}
        {locked && " · 회수완료 주문은 바꿀 수 없습니다"}
      </div>
      {error && <div className="rental-card__memo-error">{error}</div>}
    </div>
  );
}
